import URLConfig from '../service/URLConfig';
import axiosInstance from "../util/axiosInstance";
const path = URLConfig.getBasePath();


class DashboardService {

    getDashboardData() {
        return axiosInstance().get(path + "/dashboard");
    }

}

export default new DashboardService()